// Convenience wrapper for toast functionality
import { toast as baseToast } from "@/components/ui/use-toast";

export const showToast = {
  success: (message, description, duration = 3000) => {
    const toastInstance = baseToast({
      title: message,
      description,
      variant: "default",
    });
    
    setTimeout(() => {
      toastInstance.dismiss();
    }, duration);
  },
  error: (message, description, duration = 3000) => {
    const toastInstance = baseToast({
      title: message,
      description,
      variant: "destructive",
    });
    
    setTimeout(() => {
      toastInstance.dismiss();
    }, duration);
  },
  info: (message, description, duration = 3000) => {
    const toastInstance = baseToast({
      title: message,
      description,
    });
    
    setTimeout(() => {
      toastInstance.dismiss();
    }, duration);
  },
};

export default showToast;